import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import './styles/utils.css';

import reportWebVitals from './reportWebVitals';

import store from './redux/store'
import Root from './routes/Root'


ReactDOM.render(<Root store={store}/>,  document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
